module.exports = __webpack_public_path__ + "static/media/ic_outliers_hover.6468ec03.svg";